import React from "react";
import { Image, LucideMousePointerClick, MessageSquareText } from "lucide-react";
import { extractPlainText, makeEmptyDescriptionContent } from "./blogContentFormat";

export const SECTION_META = {
    description: { label: "Story text", typeClass: "description" },
    image: { label: "Image gallery", typeClass: "image" },
    button: { label: "Call to action", typeClass: "button" },
};

/** @deprecated use makeEmptyDescriptionContent — kept for imports that expect draft-shaped empty */
export const makeEmptyRaw = makeEmptyDescriptionContent;

export function countWords(sections) {
    let total = 0;
    sections.forEach((s) => {
        if (s.type === "description" && s.content) {
            total += extractPlainText(s.content).split(/\s+/).filter(Boolean).length;
        }
    });
    return total;
}

export const SectionActions = ({ onDuplicate, onDelete }) => (
    <div className="add-blog-section-actions">
        <button type="button" className="add-blog-action-btn add-blog-action-btn--dup" onClick={onDuplicate}>
            Duplicate
        </button>
        <button type="button" className="add-blog-action-btn add-blog-action-btn--del" onClick={onDelete}>
            Delete
        </button>
    </div>
);

export const EditorInsertDock = ({ addSection }) => (
    <nav className="add-blog-dock" aria-label="Insert content block">
        <button
            type="button"
            className="add-blog-dock-btn"
            title="Add text block"
            onClick={() => addSection("description")}
        >
            <MessageSquareText size={18} />
            <span className="add-blog-dock-label">Text</span>
        </button>
        <button
            type="button"
            className="add-blog-dock-btn"
            title="Add images"
            onClick={() => addSection("image")}
        >
            <Image size={18} />
            <span className="add-blog-dock-label">Images</span>
        </button>
        <button
            type="button"
            className="add-blog-dock-btn"
            title="Add button"
            onClick={() => addSection("button", { text: "", action: "" })}
        >
            <LucideMousePointerClick size={18} />
            <span className="add-blog-dock-label">Button</span>
        </button>
    </nav>
);
